export default function SvgInfos3() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        fill="none"
        viewBox="0 0 24 24"
        >
        <path
        fill="#000"
        fillRule="evenodd"
        d="M12 3.538a8.462 8.462 0 100 16.924 8.462 8.462 0 000-16.924zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
        clipRule="evenodd"
        ></path>
        <path
        fill="#000"
        fillRule="evenodd"
        d="M12 16.359a.77.77 0 00.77-.77v-4.102a.77.77 0 10-1.54 0v4.103c0 .425.345.769.77.769z"
        clipRule="evenodd"
        ></path>
        <path
        fill="#000"
        d="M13.026 8.41a1.026 1.026 0 10-2.052 0 1.026 1.026 0 002.052 0z"
        ></path>
    </svg>
  </>
  );
}
              